import { Column, Image } from '@codeparva/ui-components-library';
import React from 'react';
import { Row } from '../../../../../components/row/Row';
import { FontAwesomeIcon } from '../../../../../utilities/iconLoader/FontAwesomeIcon';
import { FooterTypes } from '../footerTypes';
import { useThemeContext } from '../hooks/themeContext';
import { getTextColor } from './ColorSelectorHelper';
import { footerConstants } from './constants';

export const selectClassNameForPoweredByLogo = (
  variant: FooterTypes.TFooterVariantModes
) => {
  switch (variant) {
    case 'footer-1':
      return 'poweredByLabel has-text-centered-desktop is-4';
    case 'footer-2':
      return 'poweredByLabel has-text-centered-desktop is-4';
    default:
      return 'poweredByLabelVariantThree has-text-centered-desktop is-4';
  }
};
export const selectClassNameForCopyRightComponent = (
  variant: FooterTypes.TFooterVariantModes
) => {
  switch (variant) {
    case 'footer-1':
      return 'is-4';
    case 'footer-2':
      return 'copyRightColumnTwo is-5 has-text-centered';
    case 'new-footer-1':
      return 'newCopyRightColumn is-4';
    default:
      return 'is-4';
  }
};

export const CopyRightComponent = ({
  labelsAndLogos,
  contactDetails,
  currentVariant,
}: FooterTypes.TCopyRights) => {
  const currTheme = useThemeContext();
  return (
    <Column className={selectClassNameForCopyRightComponent(currentVariant)}>
      <p className={`copyRight has-text-${getTextColor(currTheme)} mb-0`}>
        <FontAwesomeIcon
          iconClassName={labelsAndLogos.copyrightlogo}
          style={{
            fontSize: footerConstants.copyRightLogoSize,
          }}
        />
        &nbsp;
        {`${contactDetails && contactDetails.facilityDetails.facilityName}. ${
          footerConstants.copyRightsText
        }`}
      </p>
    </Column>
  );
};

export const PoweredByLogoComponent = ({
  currentVariant,
}: FooterTypes.TPoweredBy) => {
  const { lightTheme, darkTheme } = footerConstants.poweredByLogo;
  const currTheme = useThemeContext();
  const selectedPowerebyLogo = () => {
    return currTheme === 'dark' ? darkTheme : lightTheme;
  };
  return (
    <Column className={selectClassNameForPoweredByLogo(currentVariant)}>
      <Row className="is-justify-content-center">
        <a
          className={`has-text-${getTextColor(currTheme)} poweredBy`}
          href={footerConstants.companyWebsiteUrl}
          rel="noreferrer"
          target="_blank"
        >
          <div className="is-flex logoDiv">
            <span className="poweredByText content1">
              {footerConstants.poweredByText}
            </span>
            &nbsp;&nbsp;
            <Image
              src={selectedPowerebyLogo()}
              alt="an image of syrasoft logo"
              className={
                currentVariant === 'footer-2' || currentVariant === 'footer-3'
                  ? `syrasoftLogoVariantTwoAndThree`
                  : `syrasoftLogo`
              }
              style={{
                marginTop: 0,
                height: '2rem',
              }}
              size={128}
            ></Image>
          </div>
        </a>
      </Row>
    </Column>
  );
};
